import { PaintRowDraft } from '../types'
import { isAmountMissing } from './is-amount-missing'
import { isRowUsed } from './is-row-used'

export function getDraftIssues(drafts: PaintRowDraft[]) {
    const issues: string[] = []

    for (const draft of drafts.filter(isRowUsed)) {
        const label = `Форма ${draft.form.num ?? ''} (${draft.form.colorName ?? '—'})`

        if (!draft.portions) issues.push(`${label}: не указано количество порций`)
        if (draft.colorants.some(isAmountMissing)) {
            issues.push(`${label}: у выбранного колоранта не указаны граммы`)
        }
        if (!draft.colorants.some(cell => cell.colorantDocumentId)) {
            issues.push(`${label}: в составе нет колорантов`)
        }
    }

    return issues
}
